export const newCustomStyles = {
  control: (base: any, state: any) => ({
    ...base,
    color: '#1f2939',
    backgroundColor: '#ffffff',
    border: state.isFocused ? '1px solid #9da6b4' : '1px solid #ced5de',
    minHeight: '40px',
    height: 'fit-content',
    boxShadow: state.isFocused ? '0 0 0 4px #e0eeff' : null,
    borderRadius: '10px',
    opacity: state.isDisabled ? '0.55' : '1',

    '&:hover': {
      border: '1px solid #9da6b4',
    },
  }),

  input: (base: any) => ({
    ...base,
    marginLeft: '10px',
  }),

  placeholder: (base: any) => ({
    ...base,
    marginLeft: '10px',
    color: '#8495a9',
  }),

  loadingIndicator: (base: any) => ({
    ...base,
    alignSelf: 'flex-end',
  }),

  clearIndicator: (base: any) => ({
    ...base,
    color: '#697180',
    cursor: 'pointer',
    marginTop: '15px',
    padding: '8px 4px 8px 0',

    '&:hover': {
      color: '#9da6b4',
    },
  }),

  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#697180',
    cursor: 'pointer',
    marginTop: '10px',
    padding: '8px 4px 8px 0',

    '&:hover': {
      color: '#9da6b4',
    },
  }),

  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#f2f5f8'
      : state.isFocused
      ? '#f2f5f8'
      : '#ffffff',
    color: state.isDisabled ? '#8495a9' : '#1f2939',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',

    '&:active': {
      backgroundColor: '#f2f5f8',
    },
  }),

  menuList: (base: any) => ({
    ...base,
    borderRadius: '8px',
    padding: '4px 0 4px 0',
    boxShadow:
      '0px 2px 4px 0px rgba(15, 23, 40, 0.04), 0px 4px 8px 0px rgba(15, 23, 40, 0.12), 0px 0px 10px 6px rgba(15, 23, 40, 0.04)',

    '::-webkit-scrollbar': {
      width: '12px',
    },

    '::-webkit-scrollbar-track': {
      background: 'inherit',
    },

    '::-webkit-scrollbar-thumb': {
      background: '#e4e8ee',
      borderRadius: '100px',
      border: '4px solid #ffffff',
    },

    '::-webkit-scrollbar-thumb:hover': {
      background: '#9da6b4',
    },
  }),

  valueContainer: (base: any) => ({
    ...base,
    padding: '0',
  }),

  singleValue: (base: any) => ({
    ...base,
    backgroundColor: '#ffffff',
    padding: '8px',
    borderRadius: '6px',
    textAlign: 'start',
    textOverflow: 'ellipsis',
    lineHeight: '16px',
  }),

  multiValue: (base: any) => ({
    ...base,
    backgroundColor: '#f2f5f8',
    padding: '8px',
    borderRadius: '6px',
    lineHeight: '16px',
  }),

  multiValueLabel: (base: any) => ({
    ...base,
    padding: '0',
    textOverflow: 'clip',
    fontWeight: '400',
    fontSize: '14px',
    color: '#1f2939',
  }),

  multiValueRemove: (base: any) => ({
    ...base,
    padding: '0 2px 0 4px',
    color: '#697180',
    cursor: 'pointer',

    '&:hover': {
      color: '#9da6b4',
      backgroundColor: 'inherit',
    },

    '& > svg': {
      width: '16px',
      height: '16px',
    },
  }),

  indicatorSeparator: (state: any) => ({
    ...state,
    display: 'none',
  }),

  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: '30px',
  }),

  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }), //использовалось не везде, нужно чтобы не "просвечивало"
};
